
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcGround as ObcGroundElement} from '@oicl/openbridge-webcomponents/dist/automation/ground/ground.js';
 
 
 

 
 export const ObcGround = createComponent({
   react: React,
   tagName: 'obc-ground',
   elementClass: ObcGroundElement,
   events: {
     
   }
  });
 
 